import { Component } from '@angular/core';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['../app.component.css']
})
export class AuthComponent {
  
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.component.ts